import { Component, OnInit, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { Observable, interval, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { Store } from '@ngxs/store';
import { UiState } from '@ngxs-store/ui-store/ui.state';

@Component({
  selector: 'app-super-snackbar',
  templateUrl: './super-snackbar.component.html',
  styleUrls: ['./super-snackbar.component.scss']
})
export class SuperSnackbarComponent implements OnInit {
  isMobileMode = false;
  snackbarSelected = false;
  interval$: Observable<number>;

  constructor(
    private store: Store,
    private snackBarRef: MatSnackBarRef<SuperSnackbarComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: { message: string }) { }

  ngOnInit() {

    this.isMobileMode = this.store.selectSnapshot(UiState.getIsMobileMode);

    this.interval$ = interval(50).pipe(
      map((i) => {
        if (i === 100) {
          if (!this.snackbarSelected) {
            this.snackBarRef.dismiss();
          }
        }

        return i;
      })
    );
  }

  select() {
    if (!this.isMobileMode) {
      this.snackbarSelected = true;
      this.interval$ = of(100);
    }
  }

  close() {
    this.snackBarRef.dismiss();
  }
}
